import {
  createCoreWebCssVariables,
  createGameWebCssVariables,
  resolveLayoutMode,
  truthOrDareVisualProfile,
  type GameVisualProfile,
} from "@cue-the-night/design-system";

const profiles:
Readonly<Record<string, GameVisualProfile>> = {
  "truth-or-dare":
    truthOrDareVisualProfile,
};

let installed =
  false;

function applyVariables(
  variables:
    Readonly<
      Record<string, string>
    >,
): void {
  const root =
    document.documentElement;

  for (
    const [
      name,
      value,
    ] of Object.entries(
      variables,
    )
  ) {
    root.style.setProperty(
      name,
      value,
    );
  }
}

function updateLayoutMode():
void {
  document.documentElement
    .dataset.ctnLayout =
      resolveLayoutMode(
        window.innerWidth,
      );
}

export function installVisualFoundation():
void {
  if (installed) {
    return;
  }

  installed =
    true;

  applyVariables(
    createCoreWebCssVariables(),
  );

  updateLayoutMode();

  window.addEventListener(
    "resize",
    updateLayoutMode,
    {
      passive:
        true,
    },
  );
}

export function activateGameVisual(
  gameId:
    string,
  mechanic?:
    string,
): void {
  const profile =
    profiles[
      gameId
    ];

  if (!profile) {
    throw new Error(
      `No visual profile exists for game: ${gameId}`,
    );
  }

  const root =
    document.documentElement;

  root.dataset.ctnGame =
    gameId;

  if (mechanic) {
    root.dataset.ctnMechanic =
      mechanic;
  } else {
    delete root.dataset
      .ctnMechanic;
  }

  applyVariables(
    createGameWebCssVariables(
      profile,
    ),
  );
}
